import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const GENETICMATERIALORIGIN_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.GeneticMaterialOrigin.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const GENETICMATERIALORIGIN_CONFIG = {
  entityName: 'GeneticMaterialOrigin',
  localizationKey: 'General::Entity.GeneticMaterialOrigin',
  fields: GENETICMATERIALORIGIN_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.GeneticMaterialOrigins',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
